import { segment, vec, type Bounds } from '../geom';
import { textAt, type DimensionLayout, type DimensionLook } from '../dimensions';

/** How far a view's frame stands clear of what it holds, unless the drawing sets its own. */
export const DEFAULT_VIEW_MARGIN = 10;

/**
 * A view's frame, `margin` clear of `contents`, with its title in a band along the top, left
 * aligned; the band is two text heights tall, so the title sits one text height above the
 * contents' margin.
 */
export function viewLayout(
  contents: Bounds,
  margin: number,
  title: string,
  look: DimensionLook,
): DimensionLayout {
  const left = contents.min.x - margin;
  const right = contents.max.x + margin;
  const bottom = contents.min.y - margin;
  const top = contents.max.y + margin + look.textHeight * 2;
  const text = textAt(vec(0, 0), 0, title, look);
  return {
    strokes: [
      segment(vec(left, bottom), vec(right, bottom)),
      segment(vec(right, bottom), vec(right, top)),
      segment(vec(right, top), vec(left, top)),
      segment(vec(left, top), vec(left, bottom)),
    ],
    fills: [],
    text: {
      ...text,
      at: vec(left + look.textHeight + text.width / 2, top - look.textHeight),
    },
  };
}
